import moment from "moment";
import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Autocomplete, Box, DatePicker, FormField, Modal } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import ReportService from "services/medkit/report.service";

import { ICodename } from "commons/interfaces";
import { CustomDateRangePicker } from "components";
import { setDataAlert, showLoading } from "store/slice/common.slice";
import { IncidentReportTemplate } from "constants/enum";


const TEMPLATE_OPTIONS: ICodename[] = [
    { code: IncidentReportTemplate.Default, name: Strings.CHART.TEMPLATE_DEFAULT },
    { code: IncidentReportTemplate.SoYTe, name: Strings.CHART.TEMPLATE_SO_Y_TE },
];

const reportService = new ReportService();

const ModalSummaryNexpectedIncident = ({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const dispatch = useDispatch();
    const [error, setError] = useState<{
        dateTime?: string,
        template?: string,
    }>({});
    const [data, setData] = useState<{
        endDate?: any,
        startDate?: any,
        template?: number,
    }>({
        startDate: moment().startOf("month").unix(),
        endDate: moment().endOf("month").unix(),
        template: IncidentReportTemplate.Default,
    });

    const handleValidateData = () => {
        let checked = true;
        let newErr: any = { ...error };
        if (
            !Helpers.isNullOrEmpty(data?.endDate) &&
            !Helpers.isNullOrEmpty(data?.startDate) &&
            (data?.endDate !== "0") && (data?.endDate !== 0) &&
            (data?.startDate !== "0") && (data?.startDate !== 0)
        ) {
            newErr["dateTime"] = undefined;
        } else {
            checked = false;
            newErr["dateTime"] = Strings.CHART.PLEASE_ENTER_DATE_TIME;
        }

        if (Helpers.isNullOrEmpty(data?.template)) {
            checked = false;
            newErr["template"] = Strings.CHART.PLEASE_ENTER_TEMPLATE;
        } else {
            newErr["template"] = undefined;
        }

        !checked && setError(newErr);

        return checked;
    };

    const handleSubmit = async () => {
        if (!handleValidateData()) {
            return;
        } else {
            try {
                setError({});
                dispatch(showLoading(true));

                if (data?.template === IncidentReportTemplate.SoYTe) {
                    data.startDate = moment.unix(data.startDate).startOf("year").unix();
                    data.endDate = moment.unix(data.startDate).endOf("year").unix();
                }

                const result = await reportService.generatingUnexpectedIncidentReport({
                    endTime: data?.endDate,
                    startTime: data?.startDate,
                    template: data?.template,
                });

                const reponseBlob = new Blob([result]);

                const fileName = data?.template === IncidentReportTemplate.SoYTe
                    ? `Bao cao su co - So Y Te.docx`
                    : `Bao cao su co.docx`

                const downloadUrl = URL.createObjectURL(reponseBlob);

                const a = document.createElement("a");

                a.href = downloadUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(a);
                dispatch(setDataAlert({ message: Strings.REPORT.EXPORT_FILE_REPORT_SUCCESS, type: "success" }));
            } catch (error) {
                const message = Helpers.handleExceptionError(error);
                dispatch(setDataAlert({ message, type: "error" }));
            } finally {
                dispatch(showLoading(false));
            }
        }
    };

    return (
        <Modal
            fullWidth
            allowOutsideClick
            visible={open}
            maxWidth={"md"}
            hasActionButton
            onClose={() => {
                setOpen(false);
            }}
            onAction={() => {
                handleSubmit();
            }}
            buttonAction={Strings.COMMON.OK}
            closeButton={Strings.COMMON.CANCEL}
            title={Strings.CHART.CONDITIONS_FOR_REPORTING}
        >
            <Box sx={{ padding: "0px 16px" }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} className="mt-3">
                        <Autocomplete
                            variant="outlined"
                            data={TEMPLATE_OPTIONS}
                            label={Strings.CHART.TEMPLATE}
                            placeholder={Strings.CHART.TEMPLATE}
                            defaultValue={String(data?.template)}
                            errorMessage={error?.template}
                            onChange={(value) => {
                                setData(prev => ({
                                    ...prev,
                                    template: Helpers.isNullOrEmpty(value) ? undefined : Number(value),
                                }));
                            }}
                        />
                    </Grid>

                    {data?.template === IncidentReportTemplate.SoYTe ? (
                        <Grid item xs={12}>
                            <FormField
                                variant={"outlined"}
                                label={"Năm"}
                                type="number"
                                maxLength={4}
                                defaultValue={
                                    !Helpers.isNullOrEmpty(data?.startDate)
                                        ? moment.unix(data.startDate).year()
                                        : moment().year()}
                                placeholder={"Nhập năm muốn xuất báo cáo"}
                                onBlur={(year) => {
                                    const startOfYear = moment().year(year).startOf("year").unix();
                                    setData(prev => ({
                                        ...prev,
                                        startDate: startOfYear,
                                    }));
                                }}
                            />
                        </Grid>
                    ) : (
                        <>
                            <Grid item xs={6}>
                                <DatePicker
                                    label="Từ"
                                    placeholder="Nhập thời gian"
                                    value={data?.startDate * 1000}
                                    onChangeValue={(value) => {
                                        const val = !Helpers.isNullOrEmpty(value) ? moment(value).startOf("day").unix() : undefined;
                                        setData(prev => ({
                                            ...prev,
                                            startDate: val,
                                        }));
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DatePicker
                                    label="Đến"
                                    placeholder="Nhập thời gian"
                                    value={data?.endDate * 1000}
                                    onChangeValue={(value) => {
                                        const val = !Helpers.isNullOrEmpty(value) ? moment(value).endOf("day").unix() : undefined;
                                        setData(prev => ({
                                            ...prev,
                                            endDate: val,
                                        }));
                                    }}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
        </Modal>
    );
};


export default ModalSummaryNexpectedIncident;